import React from "react";
import { injectIntl } from "react-intl";
import { SVGView } from "../assets-view/SVGView";
import DocumentView from "../document-view/DocumentView";
import fileextension from "file-extension";
import Magnifier from "react-magnifier";
import VideoView from "../assets-view/VideoView";
import AudioView from "../assets-view/AudioView";
import { AUDIO_EXT } from "../../utils/index";
import VersionAsset2 from "../upload/VersionAsset2";
import { Tooltip } from "antd";

function ShowVersionsButton(props) {
  const {
    handleShowVersions,
    title,
    qtyVersions,
    itemSelectedFetching
  } = props;

  const finalTitle =
    itemSelectedFetching || qtyVersions <= 1
      ? title
      : `${title} (${qtyVersions})`;
  return (
    <React.Fragment>
      <div className="bb-box-edit__history" onClick={handleShowVersions}>
        {/* <Badge
                    style={{ backgroundColor: '#0096d6' }}
                    offset={[-1, 9]}
                    count={
                        qtyVersions > 1
                            ? qtyVersions
                            : undefined
                    }
                /> */}
        <div>
          {finalTitle}
          <span>
            <svg
              width="26"
              height="24"
              viewBox="0 0 26 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.1904 23.6658C13.9378 23.6658 13.6956 23.5654 13.517 23.3868C13.3384 23.2082 13.238 22.966 13.238 22.7134C13.238 22.4608 13.3384 22.2185 13.517 22.0399C13.6956 21.8613 13.9378 21.761 14.1904 21.761C16.3233 21.7613 18.3945 21.0457 20.0723 19.7287C21.75 18.4118 22.9372 16.5698 23.4435 14.4979C23.9498 12.426 23.7459 10.2441 22.8646 8.30181C21.9832 6.35954 20.4754 4.76933 18.5828 3.78598C16.6901 2.80262 14.5221 2.48305 12.4262 2.87847C10.3303 3.27389 8.42781 4.3614 7.02354 5.96677C5.61927 7.57213 4.79452 9.60241 4.68145 11.7323C4.56837 13.8622 5.17352 15.9684 6.39992 17.7134C6.54452 17.9194 6.60164 18.1744 6.55881 18.4224C6.51598 18.6705 6.37668 18.8915 6.17135 19.0372C6.06899 19.1103 5.95317 19.1623 5.83057 19.1904C5.70797 19.2185 5.58102 19.222 5.45705 19.2008C5.33309 19.1795 5.21456 19.1339 5.10831 19.0666C5.00206 18.9993 4.9102 18.9116 4.83802 18.8086C3.36643 16.7147 2.64025 14.1875 2.77582 11.6318C2.91139 9.07608 3.90087 6.63985 5.58573 4.7134C7.27059 2.78695 9.55331 1.48178 12.0682 1.00699C14.583 0.532206 17.1845 0.915285 19.4557 2.09486C21.727 3.27443 23.5366 5.18221 24.5946 7.51257C25.6526 9.84293 25.8978 12.461 25.2909 14.9473C24.6841 17.4336 23.2602 19.6442 21.2475 21.225C19.2348 22.8058 16.7497 23.6653 14.1904 23.6658Z"
                fill="#0096D6"
              />
              <path
                d="M6.57171 19.8561H1.8098C1.55722 19.8561 1.31497 19.7558 1.13637 19.5772C0.957762 19.3986 0.857422 19.1563 0.857422 18.9037C0.857422 18.6512 0.957762 18.4089 1.13637 18.2303C1.31497 18.0517 1.55722 17.9514 1.8098 17.9514H5.61933V14.1418C5.61933 13.8892 5.71967 13.647 5.89827 13.4684C6.07688 13.2898 6.31912 13.1895 6.57171 13.1895C6.8243 13.1895 7.06654 13.2898 7.24514 13.4684C7.42375 13.647 7.52409 13.8892 7.52409 14.1418V18.9037C7.52409 19.1563 7.42375 19.3986 7.24514 19.5772C7.06654 19.7558 6.8243 19.8561 6.57171 19.8561Z"
                fill="#0096D6"
              />
              <path
                d="M11.3329 16.0472C11.2076 16.048 11.0833 16.0239 10.9673 15.9766C10.8512 15.9292 10.7457 15.8593 10.6567 15.7711C10.5674 15.6825 10.4966 15.5772 10.4482 15.4611C10.3999 15.3451 10.375 15.2206 10.375 15.0949C10.375 14.9691 10.3999 14.8447 10.4482 14.7286C10.4966 14.6125 10.5674 14.5072 10.6567 14.4187L13.2377 11.8472V7.47582C13.2377 7.22323 13.338 6.98099 13.5166 6.80238C13.6952 6.62378 13.9375 6.52344 14.19 6.52344C14.4426 6.52344 14.6849 6.62378 14.8635 6.80238C15.0421 6.98099 15.1424 7.22323 15.1424 7.47582V12.2377C15.1431 12.3631 15.1191 12.4873 15.0717 12.6033C15.0243 12.7194 14.9545 12.8249 14.8662 12.9139L12.0091 15.7711C11.9201 15.8593 11.8146 15.9292 11.6985 15.9766C11.5825 16.0239 11.4582 16.048 11.3329 16.0472Z"
                fill="#0096D6"
              />
            </svg>
          </span>
        </div>
      </div>
      {/**versiones */}
    </React.Fragment>
  );
}

function validViewImage(imag) {
  const image_extensions_ok = [
    "jpeg",
    "jpg",
    "gif ",
    "bmp",
    "wbmp",
    "webp",
    "gif",
    "png"
  ];
  const ext = fileextension(imag.originalURL);
  var foundformat = image_extensions_ok.find(r => r === ext);
  if (foundformat) {
    return true;
  } else {
    return false;
  }
  // Cambio hasta aquí
}

function formatDescription(description) {
  const MAX_LENGTH = 120;
  const DOTS = "...";
  const SLICE_IN = MAX_LENGTH - DOTS.length;
  let formattedDescription = "";

  if (!description) return formattedDescription;

  const { blocks } = description;
  if (blocks && Array.isArray(blocks)) {
    blocks.forEach(
      block => (formattedDescription = formattedDescription + block.text + " ")
    );
  }
  formattedDescription = formattedDescription.trim();
  if (formattedDescription.length > MAX_LENGTH) {
    formattedDescription = formattedDescription.slice(0, SLICE_IN) + DOTS;
  }
  return formattedDescription.trim();
}
function CollectionMiddleViewAssetAndVersion(props) {
  const {
    canCommentsAndVersions,
    handleSetSrc,
    canCreateVersionDart,
    canViewVersionsDart,
    itemSelected,
    handleShowNewVersionAsset,
    handleShowVersions,
    intl,
    description,
    isFetchingAssetData,
    handleShowMessage,
    statusAsset,
    qtyVersions,
    itemSelectedFetching,
    handleSelectExpandAsset
  } = props;

  const formattedDescription = canCommentsAndVersions
    ? formatDescription(description)
    : "";

  return (
    <React.Fragment>
      <div className="bb-box-edit__image">
        <div className="bb-box-edit__thumb">
          {itemSelected.type === "image" &&
          fileextension(itemSelected.originalURL) === "svg" ? (
            <SVGView
              comFromMiddleView={true}
              src={itemSelected.originalURL}
              assetId={itemSelected._id}
            />
          ) : itemSelected.type === "image" &&
            fileextension(itemSelected.originalURL) === "png" ? (
            itemSelected.type === "image" && (
              <Magnifier
                alt={itemSelected.name}
                src={handleSetSrc(itemSelected)}
                className="responsive-img "
              />
            )
          ) : itemSelected.type === "image" && validViewImage(itemSelected) ? (
            <Magnifier
              alt={itemSelected.name}
              src={handleSetSrc(itemSelected)}
              className="responsive-img loading-middle-view"
            />
          ) : (
            itemSelected.type === "image" && (
              <DocumentView
                item={itemSelected}
                from={`middleView`}
                handleShowMessage={e => handleShowMessage(e, false)}
                handleSelectExpandAsset={handleSelectExpandAsset}
                showDocumenHover={true}
              />
            )
          )}

          {itemSelected.type === "audio" &&
            AUDIO_EXT.includes(fileextension(itemSelected.originalURL)) && (
              <AudioView
                item={itemSelected}
                from={`middleView`}
                canCommentsAndVersions={canCommentsAndVersions}
              />
            )}
          {itemSelected.type === "document" &&
            AUDIO_EXT.includes(fileextension(itemSelected.originalURL)) && (
              <AudioView
                item={itemSelected}
                from={`middleView`}
                canCommentsAndVersions={canCommentsAndVersions}
              />
            )}
          {itemSelected.type === "document" &&
            !AUDIO_EXT.includes(fileextension(itemSelected.originalURL)) && (
              <DocumentView
                item={itemSelected}
                from={`middleView`}
                handleShowMessage={e => handleShowMessage(e, false)}
                handleSelectExpandAsset={handleSelectExpandAsset}
                showDocumenHover={true}
              />
            )}
          {itemSelected.type === "font" && (
            <DocumentView
              item={itemSelected}
              from={`middleView`}
              handleShowMessage={e => handleShowMessage(e, false)}
              handleSelectExpandAsset={handleSelectExpandAsset}
              showDocumenHover={true}
            />
          )}
          {itemSelected.type === "other" && (
            <DocumentView
              item={itemSelected}
              from={`middleView`}
              handleShowMessage={e => handleShowMessage(e, false)}
              handleSelectExpandAsset={handleSelectExpandAsset}
              showDocumenHover={true}
            />
          )}
          {itemSelected.type === "video" && (
            <VideoView
              url={itemSelected.mediaQualityURL}
              disableDefaultControls={false}
              autoPlay={true}
              muted={false}
              canCommentsAndVersions={canCommentsAndVersions}
              texto="casa"
              key="vista media"
            />
          )}
        </div>
        <div className="bb-box-edit__actions">
          {canCommentsAndVersions && (
            <div className="bb-box-edit__switch">
              <div
                className={
                  isFetchingAssetData
                    ? "content-switch bb-loading"
                    : statusAsset
                    ? `content-switch bb-${statusAsset.type}`
                    : "content-switch bb-question-none"
                }
                style={
                  statusAsset && statusAsset.color && !isFetchingAssetData
                    ? {
                        border: `2px solid ${statusAsset.color}`,
                        color: statusAsset.color,
                        "--my-color-var": statusAsset.color,
                        "--my-img-var": itemSelected.document && itemSelected.document.statusAsset ? `url(/images/img_v2/icon-btn-${itemSelected.document.statusAsset.type}.${itemSelected.document.statusAsset.type === 'warning'? 'png' : 'svg'})` : null,
                      }
                    : {}
                }
              >
                {isFetchingAssetData
                  ? intl.formatMessage({
                      id: "loading"
                    })
                  : statusAsset
                  ? statusAsset.title
                  : intl.formatMessage({
                      id: "for_assignment"
                    })}
              </div>
            </div>
          )}
          {/**  esto esunaopcion de rotación  para despues*/}
          <div style={{ display: "none" }} className="bb-box-edit__rotate">
            <div>
              <svg
                width="23"
                height="26"
                viewBox="0 0 23 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22 10.2852C22 6.41916 18.866 3.28516 15 3.28516"
                  stroke="#0096D6"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M12.8371 2.87779L15.2352 0.479632C15.3624 0.352425 15.5349 0.280961 15.7148 0.280961C15.8947 0.280961 16.0673 0.352425 16.1945 0.479632C16.3217 0.606838 16.3931 0.779367 16.3931 0.959264C16.3931 1.13916 16.3217 1.31169 16.1945 1.4389L14.2759 3.35742L16.1945 5.27595C16.3217 5.40316 16.3931 5.57568 16.3931 5.75558C16.3931 5.93548 16.3217 6.10801 16.1945 6.23521C16.0673 6.36242 15.8947 6.43388 15.7148 6.43388C15.5349 6.43388 15.3624 6.36242 15.2352 6.23521L12.8371 3.83705C12.7098 3.70985 12.6384 3.53732 12.6384 3.35742C12.6384 3.17753 12.7098 3.005 12.8371 2.87779Z"
                  fill="#0096D6"
                />
                <rect
                  x="1"
                  y="10.2852"
                  width="14"
                  height="14"
                  rx="2"
                  stroke="#0096D6"
                  strokeWidth="2"
                />
              </svg>
            </div>
          </div>
        </div>
        <div className="bb-box-edit__upload">
          {canCommentsAndVersions && canCreateVersionDart && (
            <div className="bb-box-edit__input">
              <VersionAsset2
                handleShowNewVersionAsset={handleShowNewVersionAsset}
              />
            </div>
          )}
          {/**subir version */}
          {canCommentsAndVersions && canViewVersionsDart && (
            <ShowVersionsButton
              title={intl.formatMessage({ id: "versions" })}
              handleShowVersions={handleShowVersions}
              qtyVersions={qtyVersions}
              itemSelectedFetching={itemSelectedFetching}
            />
          )}
          {/**versiones */}
        </div>
        {canCommentsAndVersions &&
          !isFetchingAssetData &&
          formattedDescription.length > 0 && (
            <div className="bb-box-edit__text">
              <p className="justify_description">{formattedDescription}</p>

              <div
                className="open-box pointer"
                onClick={e => handleShowMessage(e, true)}
              >
                <Tooltip
                  placement="top"
                  title={intl.formatMessage({ id: "comments_title" })}
                >
                  <span></span>
                  <p className="read_description">Leer más</p>
                </Tooltip>
              </div>
            </div>
          )}
      </div>
      {/*FIN DIv bb-box-edit__thumb*/}
    </React.Fragment>
  );
}
export default injectIntl(CollectionMiddleViewAssetAndVersion);
